import React, { useState } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

const SearchFilter = ({ onSearch, placeholder = "Buscar...", value: externalValue, onChange: externalOnChange }) => {
  const [internalValue, setInternalValue] = useState('');

  const value = externalValue !== undefined ? externalValue : internalValue;

  const notifyValueChange = (newValue) => {
    if (externalOnChange) {
      externalOnChange({ target: { value: newValue } });
      return;
    }

    setInternalValue(newValue);
    onSearch(newValue);
  };

  const handleChange = externalOnChange || ((e) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    onSearch(newValue);
  });

  const handleClear = () => {
    notifyValueChange('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && value) {
      e.preventDefault();
      handleClear();
    }
  };

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
      />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="Limpiar búsqueda"
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default SearchFilter;